<template>
  <div>
    <section class="container-fluid my-4">
      <h4 class="my-4">Tokens da integração <strong>123Zap</strong></h4>

      <p class="text-muted">
        Gere um token de longa duração para a 123Zap consultar faturas.
        O valor secreto aparece apenas no momento da criação.
        A especificação dos endpoints está em
        <a :href="docsUrl" target="_blank" rel="noopener noreferrer">/api/documentation/partners</a>.
      </p>

      <div class="mb-4">
        <button type="button" class="btn btn-primary" @click="openCreate">
          Gerar token
        </button>
        <a :href="docsUrl" target="_blank" rel="noopener noreferrer" class="btn btn-outline-secondary ms-2">
          Documentação da API
        </a>
      </div>

      <div v-if="plainToken" class="alert alert-warning">
        <strong>Copie o token agora.</strong> Ele não será exibido novamente.
        <pre class="mt-2 mb-0" style="white-space: pre-wrap; word-break: break-all;">{{ plainToken }}</pre>
      </div>

      <table class="table table-bordered table-striped table-hover">
        <thead>
          <tr>
            <th class="text-center">#</th>
            <th>Nome</th>
            <th>Situação</th>
            <th>Permissões</th>
            <th>Último uso</th>
            <th>Criado</th>
            <th width="110px"></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in items" :key="item.id">
            <td class="text-center">{{ item.id }}</td>
            <td>{{ item.name }}</td>
            <td>{{ item.active ? 'Ativo' : 'Revogado' }}</td>
            <td>{{ (item.abilities || []).join(', ') }}</td>
            <td>{{ item.last_used_at || '—' }}</td>
            <td>{{ item.created_at }}</td>
            <td>
              <button
                v-if="item.active"
                type="button"
                class="btn btn-sm btn-outline-danger"
                @click="revoke(item.id)"
              >
                Revogar
              </button>
            </td>
          </tr>
          <tr v-if="!items.length">
            <td colspan="7" class="text-center text-muted">Nenhum token cadastrado.</td>
          </tr>
        </tbody>
      </table>
    </section>

    <div v-if="showModal" class="modal d-block" tabindex="-1" style="background: rgba(0,0,0,.35);">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Gerar token</h5>
            <button type="button" class="btn-close" @click="showModal = false"></button>
          </div>
          <div class="modal-body">
            <label class="form-label">Nome do parceiro</label>
            <input v-model="form.name" type="text" class="form-control" placeholder="123zap">
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" @click="showModal = false">Cancelar</button>
            <button type="button" class="btn btn-primary" :disabled="saving" @click="create">
              {{ saving ? 'Gerando...' : 'Gerar' }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from "@/services";
import { errorsToString } from "@/helpers";

export default {
  name: "PartnerTokenList",
  data() {
    return {
      items: [],
      showModal: false,
      saving: false,
      plainToken: null,
      form: {
        name: "123zap",
      },
    };
  },
  computed: {
    docsUrl() {
      const base = (process.env.VUE_APP_BASE_URL || "").replace(/\/$/, "");
      return `${base}/api/documentation/partners`;
    },
  },
  methods: {
    async load() {
      const { data } = await api.get("/partner-tokens");
      this.items = data.data || [];
    },
    openCreate() {
      this.form.name = "123zap";
      this.showModal = true;
    },
    async create() {
      this.saving = true;
      try {
        const { data } = await api.post("/partner-tokens", {
          name: this.form.name,
          abilities: ["invoices:read", "contacts:read"],
        });
        this.plainToken = data.data.token;
        this.showModal = false;
        await this.load();
      } catch (error) {
        alert(errorsToString(error.response?.data?.errors || { erro: [error.response?.data?.message || "Falha ao gerar token"] }));
      } finally {
        this.saving = false;
      }
    },
    async revoke(id) {
      if (!confirm("Revogar este token? A 123Zap deixará de consultar a API até um novo token ser gerado.")) {
        return;
      }
      await api.delete(`/partner-tokens/${id}`);
      if (this.plainToken) {
        this.plainToken = null;
      }
      await this.load();
    },
  },
  async mounted() {
    await this.load();
  },
};
</script>
